import React, { useState,useEffect } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import "./comdash.css";
import { FaBars, FaChevronDown, FaChevronUp, FaTimes } from "react-icons/fa";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUser, faUsers, faBriefcase, faFileAlt, faSignOutAlt, faFile, faGears } from "@fortawesome/free-solid-svg-icons";
import Cookies from "js-cookie";
import axios from "axios";
import url from "../function/url";
import CompanyNavbar from "./company/CompanyNavbar";
const Dashboard = () => {
  const ID = Cookies.get("log_id");
  const [company_name,setCompanyname] = useState("");
  const [image,setImage] = useState("");
  function  FetchCompanyDetails() {
    axios.get(`${url.path}/login_details/${ID}/`)
    .then((res) =>{
      if (res.data.status){
        setCompanyname(res.data.name);
        const img = res.data.image;
        var imag = null
        if (img) {
          imag = `${url.path}/${img}`;
        }
        setImage(imag);
      }
    })
    .catch((err) => {
      console.log("HOME ERROR==", err);
    });
  }
  useEffect(()=>{
    FetchCompanyDetails();
  },[])
    
    
  return (
    <>
    <CompanyNavbar />
        <div className="content">
          <div className="company-header">
            {image ? (
              <img
              src={image}
              alt="Company Logo"
              className="company-logo"
            />
            ) : (
              <img
              src="employer1.png"
              alt="Company Logo"
              className="company-logo"
            />
            )}
            
            <div className="company-details">
              <h2 style={{textTransform:'uppercase'}}>{company_name}</h2>
              <p></p>
              <p className="company-description">
                Company Sector
                <br />
                Lorem ipsum dolor sit amet consectetur. Sed tincidunt viverra
                eget amet a cursus sed condimentum dictum.
              </p>
              <button className="new-job-btn">Post a New Job</button>
            </div>
          </div>

          <div className="about-company">
            <h3>About Company</h3>
            <p>
              Lorem ipsum dolor sit amet consectetur. Volutpat et vivamus amet
              feugiat et nisi vulputate nullam cras. Sem quis dui metus diam in
              elit sollicitudin nec. In euismod justo sodales suscipit id duis.
            </p>
          </div>

          <div className="working-sector">
            <h3>
              Add Company Working Sector <span className="plus-circle">+</span>
            </h3>
            <div className="sectors">
              <span className="sector-tag">IT</span>
              <span className="sector-tag">Development</span>
              <span className="sector-tag">Finance</span>
            </div>
          </div>
        </div>
        </>
  );
};

export default Dashboard;
